import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { Table, Card, Button, Space, Popconfirm, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getMusicStyles } from '../../graphql/queries';
import { deleteMusicStyle } from '../../graphql/mutation';
import '../Audios/Audios.css';

const MusicStyles = () => {
  const navigate = useNavigate();

  const { loading, data, refetch } = useQuery(getMusicStyles, {
    fetchPolicy: 'network-only',
  });

  const [deleteStyle, { loading: deleting }] = useMutation(deleteMusicStyle, {
    onCompleted: () => {
      message.success('Music style deleted');
      refetch();
    },
    onError: (error) => {
      message.error(`Failed to delete: ${error.message}`);
    }
  });

  const handleDelete = (id) => {
    deleteStyle({ variables: { id } });
  };

  const columns = [
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      width: 80,
      render: (icon) => (
        <span style={{ fontSize: 24 }}>{icon}</span>
      )
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 160,
      render: (date) => dayjs(date).format('YYYY-MM-DD HH:mm')
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      align: 'center',
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/music-styles/${record.id}`);
            }}
          />
          <Popconfirm
            title="Delete this style?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="text"
              size="small"
              danger
              icon={<DeleteOutlined />}
              loading={deleting}
              onClick={(e) => e.stopPropagation()}
            />
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div className="audios-container">
      <div className="audios-header">
        <p className="audios-breadcrumb">Pages / Music Styles</p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 className="audios-title">Music Styles</h1>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/music-styles/create')}>
            Add Style
          </Button>
        </div>
      </div>

      <Card className="audios-card">
        <Table
          columns={columns}
          dataSource={data?.getMusicStyles || []}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 20,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} styles`,
          }}
          onRow={(record) => ({
            onClick: () => navigate(`/music-styles/${record.id}`),
            style: { cursor: 'pointer' }
          })}
        />
      </Card>
    </div>
  );
};

export default MusicStyles;
